import React from 'react'
import {Link} from 'react-router-dom'
import {connect} from 'react-redux'
import {Button} from 'react-bootstrap'
import {FieldGroup} from '../helpers/form'
import {withRouter} from 'react-router-dom'
import {clearUserData} from '../actions'
import * as ActionTypes from '../actionTypes'
import api from '../api'

export default class Register extends React.Component {
  render() {
    return <RegisterForm />
  }
}
@withRouter
@connect((state) => {
  return {
    isLoggedIn: state.app.isLoggedIn,
    defaultNumbers: state.defaultNumbers,
    userData: state.userData,
  }
})
@api
export class RegisterForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      user: {
        first_name: '',
        last_name: '',
        username: '',
        email: '',
        password: '',
        confirm_password: '',
      },
      submitted: false,
      is_registering_with_api: false,
      error_response: '',
    }

    if (this.props.isLoggedIn) {
      this.props.history.push('/futures')
    }

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(event) {
    const {id, value} = event.target
    const {user} = this.state
    this.setState({
      user: {
        ...user,
        [id]: value,
      },
    })
  }

  handleSubmit(event) {
    event.preventDefault()
    this.setState({submitted: true, error_response: ''})
    const {user} = this.state
    const {
      apiInstance,
      history,
      userData,
      defaultNumbers,
      dispatch,
    } = this.props

    if (
      user.first_name &&
      user.last_name &&
      user.username &&
      user.password &&
      user.email &&
      user.password === user.confirmPassword
    ) {
      this.setState({is_registering_with_api: true})
      user.backgrounders = Object.values(userData.backgrounders)
      user.finishing = Object.values(userData.finishings)
      user.projections = Object.values(userData.projections)
      user.defaultNumbers = defaultNumbers
      user.did_accept_tos = userData.didAcceptToS

      apiInstance
        .post('register', user)
        .then((response) => {
          this.setState({is_registering_with_api: false})
          if (response) {
            if (response.status === ActionTypes.API_OK) {
              window.alert(
                'Account Successfully Created! To retreive your backgrounders, finishings, and price projections please log in!',
              )
              dispatch(clearUserData())
              history.push(
                '/login?&username=' +
                  encodeURIComponent(response.data.username),
              )
            } else if (response.status === ActionTypes.API_FAIL) {
              this.setState({error_response: response.msg})
              return
            }
          } else {
            //Failed to receive response from server
            this.setState({error_response: 'Error: No Response from server'})
            return
          }
        })
        .catch((err) => {
          this.setState({is_registering_with_api: false, error_response: err})
        })
    }
  }

  render() {
    const {
      user,
      submitted,
      is_registering_with_api,
      error_response,
    } = this.state

    return (
      <div className="col-md-12">
        <form className="modal-dialog" name="form" onSubmit={this.handleSubmit}>
          <div className="col-md-12">
            <FieldGroup
              id="username"
              type="text"
              label="Username"
              placeholder="Enter username"
              onChange={this.handleChange}
            />
            {submitted &&
              !user.username && (
                <div className="help-block">Username is required</div>
              )}
          </div>
          <div className="col-md-6">
            <FieldGroup
              id="first_name"
              type="text"
              label="First Name"
              placeholder="First Name"
              onChange={this.handleChange}
            />
            {submitted &&
              !user.first_name && (
                <div className="help-block">First Name is required</div>
              )}
          </div>
          <div className="col-md-6">
            <FieldGroup
              id="last_name"
              type="text"
              label="Last Name"
              placeholder="Last Name"
              onChange={this.handleChange}
            />
            {submitted &&
              !user.last_name && (
                <div className="help-block">Last Name is required</div>
              )}
          </div>
          <div className="col-md-12">
            <FieldGroup
              id="email"
              type="text"
              label="Email"
              placeholder="Enter email"
              onChange={this.handleChange}
            />
            {submitted &&
              !user.email && (
                <div className="help-block">Email is required</div>
              )}
          </div>
          <div className="col-md-6">
            <FieldGroup
              id="password"
              type="password"
              label="Password *"
              placeholder="Enter your password"
              onChange={this.handleChange}
            />
            {submitted &&
              !user.password && (
                <div className="help-block">Password is required</div>
              )}
          </div>
          <div className="col-md-6">
            <FieldGroup
              id="confirmPassword"
              type="password"
              label="Confirm Password *"
              placeholder="Confirm Password"
              onChange={this.handleChange}
            />
            {submitted &&
              user.password !== user.confirmPassword && (
                <div className="help-block">Password must match</div>
              )}
          </div>
          {error_response.length > 0 && (
            <div className="col-md-12 error-block">{error_response}</div>
          )}
          <div className="col-md-12">
            <Button
              className="btn btn-success"
              type="submit"
              disabled={is_registering_with_api}
            >
              {is_registering_with_api ? (
                <div>
                  <i className="fa fa-spinner fa-spin" /> Registering
                </div>
              ) : (
                'Register'
              )}
            </Button>
            <Link to="/login" className="btn btn-link">
              Cancel
            </Link>
          </div>
        </form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/register.js